TreasureBoxManager = xClass("TreasureBoxManager")
let ShareUtil = require("clover/utils/ShareUtil")
var CommonRewardPanel = require("clover/panel/CommonRewardPanel")[0]
let instance = null
TreasureBoxManager.getInstance = function () {
    let self = this
    if (!instance) {
        instance = TreasureBoxManager.create()
        instance.init()
    }
    return instance
}

TreasureBoxManager.prototype.isOpen = function () {
    var self = this
    // UserManager.getInstance().getUserRef().getTopLevelId() > 30
    return self.data && self.data.isOpen
}

TreasureBoxManager.prototype.init = function () {
    var self = this
    self.data = null
    //  真实分享标记
    self.isRealShare = MetaManager.isUseRealShareOnSpecialModule("redbag") || false;
}

TreasureBoxManager.prototype.setTreasurePanel = function (panel) {
    var self = this
    self.panel = panel
}
TreasureBoxManager.prototype.setData = function(data) {
    var self = this
    self.data = data;
}
TreasureBoxManager.prototype.getData = function() {
    return this.data
}
TreasureBoxManager.prototype.isHaveReward = function() {
    var self = this
    var result = false
    if(self.data != null) {
        if(self.data.rewardState==1) {
            result = true
        }else{
            for(var i=1;i<self.data.bags.length;i++) {
                let obj = self.data.bags[i]
                if(obj.helper!=null && !obj.rewardGet) {
                    result = true
                    break
                }
            }
        }
    }
    return result
}
TreasureBoxManager.prototype.getInfo = function (succFunc, failFunc) {
    let self = this
    // body
    function onSuccess(evt) {
        // body
        let data = evt.data
        self.setData(data)
        if(succFunc) {
            succFunc()
        }
    }
    function onError() {
        if(failFunc) {
            failFunc()
        }
    }
    function onCancel() {
        if(failFunc) {
            failFunc()
        }
    }
    let http = TreasureBoxGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load()
}
TreasureBoxManager.prototype.shareWX = function() {
    var self = this;
    let onFail = ()=> {
        Toast.make(getText("activity.sharefailed"));
    }
    if (self.isRealShare) {
        function onGetSuccess(evt) {
            let data = evt.data
            let title = "获得奖励"
            var rewardItems = data.rewardItems
            for (var k = 1, v = rewardItems[1]; v; k++ , v = rewardItems[k]) {
                UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.GIFT, {
                    category: "share",
                    sub_category: "treasure_box" 
                })
            }
            CommonRewardPanel.show(title, null, rewardItems, function () {})
            if(self.panel) {
                self.panel.refresh()
            }
        }

        function onGetFail(evt) {
            Toast.make(curryQuickGetErrorText(0));
        }

        function onShareSuccess() {
            let http = GetRedbagRealShareSuccessHttp.new(true)
            http.addEventListener(Events.kComplete, onGetSuccess)
            http.addEventListener(Events.kError, onGetFail)
            http.addEventListener(Events.kCancel, onGetFail)
            http.load(1)
        }
        function onNewSuccess(evt) {
            ShareUtil.clickTreasureBox(Localhost.time(), evt.data.shareId || "", onShareSuccess, onFail, onFail);
        }
        let http = GetRedbagRealShareIdHttp.new(true)
        http.addEventListener(Events.kComplete, onNewSuccess)
        http.addEventListener(Events.kError, onFail)
        http.addEventListener(Events.kCancel, onFail)
        http.load()
    } else {
        ShareUtil.clickTreasureBox(Localhost.time(), "", null, onFail, onFail);
    }
}
TreasureBoxManager.prototype.getReward = function(itemIdx, callback) {
    let self = this

    if (self.isBusy) {
        return
    }
    self.isBusy = true

    // body
    function onSuccess(evt) {
        // body
        self.isBusy = false
        let data = evt.data
        let title = data.newUser?"恭喜获得3倍奖励":"获得奖励"
        var rewardItems = table({itemId:data.itemId, num:data.itemNum})
        CommonRewardPanel.show(title, null, rewardItems, function () {})
        if(self.panel) {
            self.panel.refresh()
        }
        for (var k = 1, v = rewardItems[1]; v; k++ , v = rewardItems[k]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.GIFT, {
                category: "share",
                sub_category: "treasure_box" 
            })
        }
        if(callback) {
            callback()
        }
    }
    function onError(evt) {
        self.isBusy = false
        Toast.make(quickGetErrorText(evt.data, "网络异常，请稍后再试！"))
        // Toast.make(getText("error.tip.load_res_error"))
    }
    function onCancel(evt) {
        self.isBusy = false
        Toast.make(quickGetErrorText(evt.data, "网络异常，请稍后再试！"))
    }
    let http = TreasureBoxGetRewardHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load(itemIdx)
}
TreasureBoxManager.prototype.getBigReward = function(callback) {
    let self = this

    if (self.isBusy) {
        return
    }
    self.isBusy = true

    // body
    function onSuccess(evt) {
        // body
        self.isBusy = false
        let data = evt.data
        let title = "获得奖励"
        var rewardItems = data.bigRewards
        for (var k = 1, v = rewardItems[1]; v; k++ , v = rewardItems[k]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.GIFT, {
                category: "share",
                sub_category: "treasure_box" 
            })
        }
        CommonRewardPanel.show(title, null, rewardItems, function () {})
        if(self.panel) {
            self.panel.refresh()
        }
        if(callback) {
            callback()
        }
    }
    function onError(evt) {
        self.isBusy = false
        Toast.make(quickGetErrorText(evt.data, "网络异常，请稍后再试！"))
        // Toast.make(getText("error.tip.load_res_error"))
    }
    function onCancel(evt) {
        self.isBusy = false
        Toast.make(quickGetErrorText(evt.data, "网络异常，请稍后再试！"))
    }
    let http = TreasureBoxGetBigRewardHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onError)
    http.addEventListener(Events.kCancel, onCancel)
    http.load()
}
TreasureBoxManager.prototype.getRealShareReward = function(callback, type) {
    let self = this

    if (self.isBusy) {
        return
    }
    self.isBusy = true

    function onGetSuccess(evt) {
        self.isBusy = false
        let data = evt.data
        let title = "获得奖励"
        var rewardItems = data.rewardItems
        for (var k = 1, v = rewardItems[1]; v; k++ , v = rewardItems[k]) {
            UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.GIFT, {
                category: "share",
                sub_category: "treasure_box" 
            })
        }
        CommonRewardPanel.show(title, null, rewardItems, function () {})
        if(self.panel) {
            self.panel.refresh()
        }
        if(callback) {
            callback()
        }
    }
    function onGetError(evt) {
        self.isBusy = false
        Toast.make(quickGetErrorText(evt.data, "网络异常，请稍后再试！"))
    }
    function onGetCancel(evt) {
        self.isBusy = false
        Toast.make(quickGetErrorText(evt.data, "网络异常，请稍后再试！"))
    }
    let http = GetRedbagRealShareSuccessHttp.new(true)
    http.addEventListener(Events.kComplete, onGetSuccess)
    http.addEventListener(Events.kError, onGetError)
    http.addEventListener(Events.kCancel, onGetCancel)
    http.load(type)
}
module.exports = TreasureBoxManager